import styles from './NaviTableHeader.module.scss';
import cx from 'classnames';
import NaviTableHeaderCell from './NaviTableHeaderCell';
import { INaviTableHeaderRow, NaviTableVariants } from '../../interfaces';
import { RowData } from '@tanstack/react-table';
import { useNaviTableContext } from '../../context/NaviTableContext';

const NaviTableHeaderRow = <TData extends RowData>({ headerGroup }: INaviTableHeaderRow<TData>) => {
  const { variant = NaviTableVariants.DEFAULT } = useNaviTableContext<TData>();
  return (
    <div
      className={cx({
        [styles.naviTableHeaderRow]: variant === NaviTableVariants.DEFAULT,
        [styles.naviTableHeaderRowCard]: variant === NaviTableVariants.CARDS
      })}
    >
      {headerGroup.headers.map(header => (
        <NaviTableHeaderCell key={header.id} header={header} />
      ))}
    </div>
  );
};

export default NaviTableHeaderRow;
